/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import React, { useState, useContext, useEffect } from 'react';
import { Button, Form, FormGroup, Label, Input, InputGroup, InputGroupAddon } from 'reactstrap';
import { Link } from 'react-router-dom';
import Alert from 'react-s-alert';
import 'react-phone-input-2/lib/style.css';

// import contexts
import { ThemeContext } from '../../contexts/ThemeContext';

// import services
import GeneralService from '../../services/GeneralService';

// local imports
import ErrorBoundary from '../general/ErrorBoundary';
import Message from '../general/Message';
import GeneralNavbar from '../general/GeneralNavbar';
import Footer from '../general/Footer';
import BecomeClient from '../../assets/becomeClient.svg';

const ClientLandingScreen = props => {

    // contexts
    const { theme, fontFamily, fontWeight, colors } = useContext(ThemeContext);

    // states
    const [message, setMessage] = useState(null);
    const [requirementsList, setRequirementsList] = useState([false, false, false, false, false]);
    const [provider, setProvider] = useState({
        firstName: "",
        lastName: "",
        email: "",
        phone: ""
    });
    const [isLoading, setIsLoading] = useState(false);

    //scroll to top
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const performOnClick = (id) => {
        document.getElementById(id).click();
    }

    // handle functions
    const handleChange = e => {
        try {
            if (e.target.name === "phone") {
                const re = /^[0-9\b]+$/;
                // if value is not blank, then test the regex
                if (e.target.value === '' || re.test(e.target.value)) {
                    setProvider({ ...provider, [e.target.name]: e.target.value });
                }
            } else {
                setProvider({ ...provider, [e.target.name]: e.target.value });
            }
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Client ClientLandingScreen handlechange', 'Error in try catch block', err.stack);
        }
    }

    const handleSubmit = e => {
        e.preventDefault();
        try {
            if (requirementsList[0] && requirementsList[1] && requirementsList[2] && requirementsList[3] && requirementsList[4]) {
                setIsLoading(true);
                GeneralService.providerSignup(provider)
                    .then(data => {
                        setMessage(data.message);
                        setProvider({ email: "", firstName: "", lastName: "", phone: "" });
                        setIsLoading(false);
                    });
            } else {
                setMessage({ msgError: true, msgBody: "You must need to follow all requirements" });
            }
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Client ClientLandingScreen handleSubmit', 'Error in try catch block', err.stack);
            setIsLoading(false);
        }
    }

    // function's return
    return (
        <div style={{ fontFamily: fontFamily.primary }}>
            <ErrorBoundary errorAt="At Client ProviderLandingScreen GeneralNavbar">
                <GeneralNavbar history={props.history} />
            </ErrorBoundary>

            <div className="p-3">
                <h1 className="mx-auto text-center" id="client-landing-heading" style={{ fontSize: "2rem" }}>Seek counselling services</h1>

                <div className="row p-3">
                    <img id="client-landingscreen-img" className="col-md-6 col-12" src={BecomeClient} alt="Work from your comfort" />

                    <div className="col-md-6 col-12 my-auto">
                        <h2 id="client-counselling-comfort" style={{ fontSize: "1.5rem" }}>Counselling from your Comfort</h2>
                        <p id="client-counselling-comfor-paragraph" style={{ fontSize: "1.5rem" }}>
                            <ul>
                                <li id="client-counselling-comfort-p1">Get help from your choice of counsellor on the platform</li>
                                <li id="client-counselling-comfort-p2">Decide mode of live session from Chat, Call and Video</li>
                                <li id="client-counselling-comfort-p3">Chat with your counsellor anytime through Chat Subscriptions</li>
                            </ul>
                        </p>
                    </div>
                </div>

                <div className='mt-5 mb-3 text-center'>
                    <Button id="client-seek-counsellingBtn" style={theme.buttonRounded} onClick={() => props.history.push('/client/signup-step1')}>Seek counselling</Button>
                </div>
            </div>
            <Footer />
        </div>
    )
}
export default ClientLandingScreen;



